<template>
  <div class="e4s-flex-column">
    <div class="e4s-flex-column e4s-results-sticky-header">
      <div class="e4s-top-nav e4s-flex-row">
        <SectionLinkSimple
          link-title="Schedule"
          :is-active="storeCompResults.state.ui.showSection === 'SCHEDULE'"
          @selected="storeCompResults.state.ui.showSection = 'SCHEDULE'"
        >
          <div class="e4s-header--400 e4s-justify-flex-row-vert-center">Schedule</div>
        </SectionLinkSimple>

        <SectionLinkSimple
          link-title="Athletes"
          :is-active="storeCompResults.state.ui.showSection === 'ATHLETES'"
          @selected="storeCompResults.state.ui.showSection = 'ATHLETES'"
        >
          <div class="e4s-header--400 e4s-justify-flex-row-vert-center">Athletes</div>
        </SectionLinkSimple>

        <SectionLinkSimple
          v-if="storeCompResults.state.ui.showSection === 'EVENT_DETAIL'"
          :is-active="storeCompResults.state.ui.showSection === 'EVENT_DETAIL'"
          @selected="storeCompResults.state.ui.showSection === 'EVENT_DETAIL'"
        >
          <div class="e4s-header--400 e4s-justify-flex-row-vert-center">Details</div>
        </SectionLinkSimple>

        <SectionLinkSimple
          :is-active="storeCompResults.state.ui.showSection === 'LIVE_FEED'"
          @selected="storeCompResults.state.ui.showSection = 'LIVE_FEED'"
        >
          <div
            class="e4s-header--400 e4s-justify-flex-row-vert-center"
            v-if="!storeCompResults.isCompetitionOver.value"
          >
            Live Feed
            <!--            <Lightning v-if="storeCompResults.state.socket.isConnected" />-->
            <!--            <LightningSlash v-if="!storeCompResults.state.socket.isConnected" />-->
            <PulseIndicator
              color="var(--socket-inactive-color)"
              :animate="false"
              v-if="!storeCompResults.state.socket.isConnected"
            />
            <PulseIndicator
              color="var(--socket-active-color)"
              :animate="true"
              v-if="storeCompResults.state.socket.isConnected"
            />
          </div>
        </SectionLinkSimple>

        <SectionLinkSimple
          v-if="storeCompResults.state.hasTeamResults"
          :is-active="storeCompResults.state.ui.showSection === 'TEAM_RESULTS'"
          @selected="storeCompResults.state.ui.showSection = 'TEAM_RESULTS'"
        >
          <div class="e4s-header--400 e4s-justify-flex-row-vert-center">Team Results</div>
        </SectionLinkSimple>

        <SectionLinkSimple
          v-if="storeCompResults.state.hasIndivSeries"
          :is-active="storeCompResults.state.ui.showSection === 'INDIVIDUAL_RESULTS'"
          @selected="storeCompResults.state.ui.showSection = 'INDIVIDUAL_RESULTS'"
        >
          <div class="e4s-header--400 e4s-justify-flex-row-vert-center">Series Results</div>
        </SectionLinkSimple>

        <!-- <SectionLinkSimple link-title="111" :is-active="false" class="e4s-flex-row--end">
          <span
            v-text="storeCompResults.getCompetitionCachedTime.value"
            class="e4s-subheader--general"
          ></span>
        </SectionLinkSimple> -->
        <!-- <SectionLinkSimple
          :is-active="storeCompResults.state.ui.showSection === 'FILTERS'"
          :class="{
            'e4s-tab-link--has-filters': storeCompResults.state.schedule.filterIsEnabled.any
          }"
          @selected="storeCompResults.state.ui.showSection = 'FILTERS'"
        >
          <span class="e4s-header--400">Filters</span>
          <span
            v-if="storeCompResults.state.schedule.filterIsEnabled.count > 0"
            class="e4s-filter-badge"
            v-text="storeCompResults.state.schedule.filterIsEnabled.count"
          ></span>
        </SectionLinkSimple> -->
      </div>
      <ul
        class="e4s-sub-nav e4s-flex-row"
        v-if="storeCompResults.state.ui.showSection === 'EVENT_DETAIL'"
      >
        <SubNavLink link-title="Details >" class="e4s-sub-nav--inert" />

        <SubNavLink
          link-title="Entries"
          :is-active="storeCompResults.state.ui.eventDetail.showTab === 'DETAIL_ENTRIES'"
          @selected="storeCompResults.state.ui.eventDetail.showTab = 'DETAIL_ENTRIES'"
        />

        <li class="e4s-sub-nav-link--sep" v-if="storeCompResults.showStartListTab.value">|</li>

        <SubNavLink
          link-title="Start List"
          v-if="storeCompResults.showStartListTab.value"
          :is-disabled="storeCompResults.state.selectedEvent.isTeam"
          :is-active="storeCompResults.state.ui.eventDetail.showTab === 'DETAIL_START_LIST'"
          @selected="storeCompResults.state.ui.eventDetail.showTab = 'DETAIL_START_LIST'"
        />

        <li class="e4s-sub-nav-link--sep">|</li>

        <SubNavLink
          link-title="Results"
          :is-active="storeCompResults.state.ui.eventDetail.showTab === 'DETAIL_RESULTS'"
          @selected="storeCompResults.state.ui.eventDetail.showTab = 'DETAIL_RESULTS'"
        />
      </ul>
    </div>

    <!-- cardInfo: {{ storeCompResults.state.competitionOnTheDay.options.cardInfo }}

    showStartListTab: {{ storeCompResults.showStartListTab.value }}

    <div>cardInfo: {{ storeCompResults.state.competitionOnTheDay.options }}</div> -->

    <div class="e4s-flex-column e4s-gap--standard">
      <div
        class="e4s-flex-column e4s-gap--standard"
        v-if="storeCompResults.state.isLoading || !storeCompResults.state.isReady"
      >
        <LoadingSpinnerV2 :loading-message="storeCompResults.state.loadingMessage" />
      </div>
      <!--    <ResultsCompHeader-->
      <!--      :competition-on-the-day="storeCompResults.state.competitionOnTheDay"-->
      <!--      v-if="!isEmbedded"-->
      <!--    />-->

      <div class="e4s-content-wrapper-new-xxx">
        <!--        <ResultsCompHeader-->
        <!--          :competition-on-the-day="storeCompResults.state.competitionOnTheDay"-->
        <!--          v-if="!isEmbedded"-->
        <!--        />-->

        <div v-if="storeCompResults.state.isReady">
          <!--Filters-->
          <!--        v-if="!storeCompResults.state.ui.showFollowEventSetup"-->

          <div
            v-show="storeCompResults.state.ui.showSection === 'FILTERS'"
            class="e4s-flex-row e4s-gap--standard"
          >
            <div
              class="e4s-flex-row e4s-justify-flex-row-vert-center e4s-gap--standard e4s-justify-flex-space-between"
            >
              <FormGenericInputTemplate
                form-label="Date"
                :show-label="false"
                v-if="storeCompResults.state.dates.length > 1"
              >
                <template #field>
                  <FieldSelect
                    :class="
                      storeCompResults.state.schedule.filterIsEnabled.date
                        ? 'e4s-input-field--highlight'
                        : ''
                    "
                    :data-array="storeCompResults.state.dates"
                    :value="storeCompResults.state.schedule.filterDate"
                    @input="storeCompResults.filterScheduleDate"
                  >
                    <template #default="{ obj }">
                      <span v-text="formatDateWithSuffix(obj as string)"></span>
                    </template>
                  </FieldSelect>
                </template>
              </FormGenericInputTemplate>

              <FormGenericInputTemplate form-label="Type" :show-label="false">
                <template #field>
                  <EventTypeSelect
                    :class="
                      storeCompResults.state.schedule.filterIsEnabled.eventType
                        ? 'e4s-input-field--highlight'
                        : ''
                    "
                    :value="storeCompResults.state.schedule.filterEventType"
                    :event-types="storeCompResults.state.schedule.eventTypesAvailable"
                    @input="storeCompResults.setEventTypeFilter"
                  />
                </template>
              </FormGenericInputTemplate>
            </div>

            <InputDebounce
              class="e4s-flex-grow e4s-justify-flex-row-vert-center"
              :class="
                storeCompResults.state.schedule.filterIsEnabled.term
                  ? 'e4s-input-field--highlight'
                  : ''
              "
              :value="storeCompResults.state.schedule.filterTerm"
              @input="storeCompResults.filterSchedule"
              placeholder="Filter..."
              style="min-width: 0"
            />
          </div>
          <!--/Filters-->

          <!--SCHEDULE-->
          <div
            v-show="storeCompResults.state.ui.showSection === 'SCHEDULE'"
            class="e4s-flex-column e4s-content-wrapper-new"
          >
            <div class="e4s-vertical-spacer--standard"></div>

            <!--Filters-->
            <!--        v-if="!storeCompResults.state.ui.showFollowEventSetup"-->
            <div
              v-if="true"
              class="e4s-flex-row e4s-gap--standard e4s-justify-flex-row-vert-center"
            >
              <div class="e4s-flex-row e4s-gap--standard e4s-justify-flex-space-between">
                <FormGenericInputTemplate
                  form-label="Date"
                  :show-label="false"
                  v-if="storeCompResults.state.dates.length > 1"
                >
                  <template #field>
                    <FieldSelect
                      :class="
                        storeCompResults.state.schedule.filterIsEnabled.date
                          ? 'e4s-input-field--highlight'
                          : ''
                      "
                      :data-array="storeCompResults.state.dates"
                      :value="storeCompResults.state.schedule.filterDate"
                      @input="storeCompResults.filterScheduleDate"
                    >
                      <template #default="{ obj }">
                        <span v-text="formatDateWithSuffix(obj as string)"></span>
                      </template>
                    </FieldSelect>
                  </template>
                </FormGenericInputTemplate>

                <FormGenericInputTemplate form-label="Type" :show-label="false">
                  <template #field>
                    <EventTypeSelect
                      :class="
                        storeCompResults.state.schedule.filterIsEnabled.eventType
                          ? 'e4s-input-field--highlight'
                          : ''
                      "
                      :value="storeCompResults.state.schedule.filterEventType"
                      :event-types="storeCompResults.state.schedule.eventTypesAvailable"
                      @input="storeCompResults.setEventTypeFilter"
                    />
                  </template>
                </FormGenericInputTemplate>
              </div>

              <InputDebounce
                class="e4s-flex-grow e4s-justify-flex-row-vert-center"
                :class="
                  storeCompResults.state.schedule.filterIsEnabled.term
                    ? 'e4s-input-field--highlight'
                    : ''
                "
                :value="storeCompResults.state.schedule.filterTerm"
                @input="storeCompResults.filterSchedule"
                placeholder="Filter..."
                style="min-width: 0"
              />
            </div>
            <!--/Filters-->

            <div class="e4s-vertical-spacer--standard"></div>
            <div class="e4s-flex-row">
              <CollapseActivator
                class="e4s-flex-row--end"
                :show-left="false"
                @isOpen="storeCompResults.setShowFollowEventSetup"
              >
                <template #title-slot>
                  <div class="e4s-flex-row e4s-gap--standard e4s-justify-flex-row-vert-center">
                    <PulseIndicator
                      v-if="
                        storeCompResults.followingEventCount.value > 0 &&
                        !storeCompResults.isCompetitionOver.value
                      "
                      color="var(--socket-active-color)"
                      :animate="true"
                    />
                    <span
                      class="e4s-subheader--300xxx"
                      style="font-weight: bold"
                      :style="storeCompResults.state.ui.showFollowEventSetup ? 'color: red;' : ''"
                      v-text="
                        'Following events' +
                        (storeCompResults.followingEventCount.value > 0
                          ? ' (' + storeCompResults.followingEventCount.value + ')'
                          : '')
                      "
                    ></span>
                  </div>
                </template>
              </CollapseActivator>
            </div>

            <!--Following-->
            <div
              v-if="storeCompResults.state.ui.showFollowEventSetup"
              class="e4s-flex-column e4s-gap--standard"
            >
              <div class="e4s-flex-column e4s-gap--large">
                <div class="e4s-flex-column e4s-gap--standard">
                  <div class="e4s-vertical-spacer--standard"></div>
                  <p>
                    Follow specific event(s) below and receive notifications when a result comes in
                    on the <span class="e4s-header--500">Live Feed</span>.
                  </p>
                  <p>None selected will default to live notifications for all events.</p>
                </div>
              </div>
              <!--          <FollowingWithButtons-->
              <!--            v-if="storeCompResults.followingEventCount.value > 0"-->
              <!--            :following-events="storeCompResults.state.socket.followingEvents"-->
              <!--            @shouldFollowEvent="storeCompResults.shouldFollowEvent"-->
              <!--          />-->
              <!--          <hr class="dat-e4s-hr-only dat-e4s-hr&#45;&#45;light" />-->
            </div>
            <!--/Following-->

            <div class="e4s-vertical-spacer--large"></div>

            <hr class="dat-e4s-hr-only" />

            <ResultsSchedule
              :store-comp-results-state="storeCompResults.state"
              :scheduled-events="storeCompResults.state.scheduledEvents"
              :show-follow-event-setup="storeCompResults.state.ui.showFollowEventSetup"
              :following-events="storeCompResults.state.socket.followingEvents"
              @show-details="storeCompResults.showDetails"
              @shouldFollowEvent="storeCompResults.shouldFollowEvent"
            />
          </div>
          <!--/SCHEDULE-->

          <!--ATHLETES-->
          <div
            v-show="storeCompResults.state.ui.showSection === 'ATHLETES'"
            class="e4s-flex-column e4s-content-wrapper-new"
          >
            <div class="e4s-vertical-spacer--standard"></div>
            <ResultsAthletes :store-comp-results-state="storeCompResults.state" />
          </div>
          <!--/ATHLETES-->

          <!--LIVE_FEED-->
          <div
            v-show="storeCompResults.state.ui.showSection === 'LIVE_FEED'"
            class="e4s-flex-column e4s-content-wrapper-new"
          >
            <div class="e4s-vertical-spacer--standard"></div>

            <div class="e4s-flex-row">
              <FollowingWithButtons
                :following-events="storeCompResults.state.socket.followingEvents"
                @shouldFollowEvent="storeCompResults.shouldFollowEvent"
              >
                <template #change-following>
                  <PrimaryLink
                    link-text="Change"
                    @click="storeCompResults.state.ui.showSection = 'SCHEDULE'"
                  />
                </template>
              </FollowingWithButtons>

              <div class="e4s-flex-row--end">
                <span
                  >Most recent
                  {{ storeCompResults.state.socket.liveFeedSocketMessages.length }}</span
                >
              </div>
            </div>

            <div class="e4s-vertical-spacer--standard"></div>

            <LiveFeedSockets
              :store-comp-results-state="storeCompResults.state"
              :live-feed="storeCompResults.state.socket.liveFeedSocketMessages"
              :following-events="storeCompResults.state.socket.followingEvents"
            />
          </div>
          <!--/LIVE_FEED-->

          <!--TEAM_RESULTS-->
          <div
            v-show="storeCompResults.state.ui.showSection === 'TEAM_RESULTS'"
            class="e4s-flex-column e4s-content-wrapper-new"
          >
            <div class="e4s-vertical-spacer--standard"></div>

            <TeamResults
              v-if="storeCompResults.state.apiServerResponse?.data"
              :store-comp-results-state="storeCompResults.state"
            />
          </div>
          <!--/TEAM_RESULTS-->

          <!--INDIVIDUAL_RESULTS-->
          <div
            v-show="storeCompResults.state.ui.showSection === 'INDIVIDUAL_RESULTS'"
            class="e4s-flex-column e4s-content-wrapper-new"
          >
            <div class="e4s-vertical-spacer--standard"></div>

            <IndividualResults
              :indiv-series-scheduled-items="storeCompResults.state.indivSeriesScheduledItems"
              :indiv-results-data="storeCompResults.state.indivResultsData"
              :indiv-results-selected-event-group-id="
                storeCompResults.state.indivResultsSelectedEventGroupId
              "
              :indiv-results-loading="storeCompResults.state.indivResultsLoading"
              :indiv-results-error="storeCompResults.state.indivResultsError"
              @update:selected-event-group-id="
                storeCompResults.state.indivResultsSelectedEventGroupId = $event
              "
              @update:loading="storeCompResults.state.indivResultsLoading = $event"
              @update:error="storeCompResults.state.indivResultsError = $event"
              @update:results-data="storeCompResults.state.indivResultsData = $event"
            />
          </div>
          <!--/INDIVIDUAL_RESULTS-->

          <!--EVENT_DETAIL-->
          <div v-if="storeCompResults.state.ui.showSection === 'EVENT_DETAIL'">
            <!--EVENT_DETAIL_STICKY_HEADER-->
            <div class="e4s-flex-column e4s-gap--standard-x e4s-event-detail-sticky-header">
              <div class="e4s-flex-row">
                <span
                  class="e4s-header--400"
                  v-text="storeCompResults.getSelectedCompEventTitle.value"
                ></span>

                <span
                  class="e4s-header--400 e4s-flex-row--end vertical-align--middle"
                  v-text="
                    storeCompResults.state.selectedEvent.eventDateDisplay +
                    '@' +
                    storeCompResults.state.selectedEvent.eventTimeDisplay
                  "
                ></span>
              </div>

              <div class="e4s-flex-row" v-if="storeCompResults.doesSelectedEventHaveEgRules.value">
                <span class="e4s-header--500 e4s-subheader--general-x"
                  >To Qualify:
                  <span v-text="storeCompResults.getSelectedEventQualifyRules.value"></span
                ></span>
              </div>

              <div class="e4s-flex-row" v-if="storeCompResults.doesSelectedEventHaveTrials.value">
                <span class="e4s-header--500 e4s-subheader--general-x">
                  <span v-text="storeCompResults.getSelectedEventTrialsDescription.value"></span
                ></span>
              </div>

              <div class="e4s-flex-column e4s-gap--small">
                <div class="e4s-flex-row">
                  <span
                    class="e4s-header--500 e4s-subheader--general"
                    v-text="storeCompResults.getSelectedEventAgeGroup.value"
                  ></span>

                  <div class="e4s-flex-row--end">
                    <EventJumpSelect
                      :events="storeCompResults.state.scheduledEvents"
                      :selected-eg-id="storeCompResults.state.selectedEvent.compEvent.egId"
                      @on-event-jump="handleEventJump"
                    />
                  </div>
                </div>

                <div
                  class="e4s-flex-row e4s-gap--standard e4s-flex-row--end e4s-justify-flex-row-vert-center"
                >
                  <ButtonGenericV2
                    v-if="storeCompResults.getQualifyFrom.value"
                    button-type="primary"
                    class="e4s-button--slim e4s-button--prev-next"
                    :text="'<< ' + storeCompResults.getQualifyFrom.value.name"
                    @onButtonClicked="
                      storeCompResults.gotoQualifyingEvent(
                        storeCompResults.getQualifyFrom.value.egId.toString()
                      )
                    "
                  />

                  <ButtonGenericV2
                    v-if="storeCompResults.getQualifyTo.value"
                    button-type="primary"
                    class="e4s-button--slim e4s-button--prev-next"
                    :text="storeCompResults.getQualifyTo.value.name + ' >>'"
                    @onButtonClicked="
                      storeCompResults.gotoQualifyingEvent(
                        storeCompResults.getQualifyTo.value.egId.toString()
                      )
                    "
                  />

                  <ButtonGenericV2
                    class="e4s-button--slim e4s-button--prev-next e4s-button--arrow"
                    button-type="primary"
                    text="<"
                    :disabled="storeCompResults.isSelectedEventFirst.value"
                    @onButtonClicked="storeCompResults.gotoPreviousEvent('T')"
                  />
                  <ButtonGenericV2
                    class="e4s-button--slim e4s-button--prev-next e4s-button--arrow"
                    button-type="primary"
                    text=">"
                    :disabled="storeCompResults.isSelectedEventLast.value"
                    @onButtonClicked="storeCompResults.gotoNextEvent('T')"
                  />
                </div>
              </div>
            </div>
            <!--/EVENT_DETAIL_STICKY_HEADER-->

            <!--EVENT_DETAIL_CONTENT-->
            <div class="e4s-content-wrapper-new">
              <div class="e4s-vertical-spacer--standard"></div>

              <template v-if="storeCompResults.state.ui.eventDetail.showTab === 'DETAIL_ENTRIES'">
                <ResultsEntries
                  class="e4s-content-wrapper-new"
                  :store-comp-results-state="storeCompResults.state"
                  :scheduled-event="storeCompResults.state.selectedEvent.compEvent"
                  :filter-search-term="storeCompResults.state.selectedEvent.searchTerm"
                  :is-track="storeCompResults.isSelectedEventTrack.value"
                  @searchTermChanged="storeCompResults.searchTermChanged"
                  v-if="!storeCompResults.state.selectedEvent.isTeam"
                />
                <ResultsTeamEntries
                  :store-comp-results-state="storeCompResults.state"
                  :scheduled-event="storeCompResults.state.selectedEvent.compEvent"
                  @searchTermChanged="storeCompResults.searchTermChanged"
                  v-if="storeCompResults.state.selectedEvent.isTeam"
                />
              </template>

              <StartList
                v-if="storeCompResults.state.ui.eventDetail.showTab === 'DETAIL_START_LIST'"
                :store-comp-results-state="storeCompResults.state"
                :comp-event="storeCompResults.state.selectedEvent.compEventFiltered"
                @searchTermChanged="storeCompResults.searchTermChanged"
                :filter-search-term="storeCompResults.state.selectedEvent.searchTerm"
              />

              <HeatResults
                v-if="storeCompResults.state.ui.eventDetail.showTab === 'DETAIL_RESULTS'"
                :store-comp-results-state="storeCompResults.state"
                :scheduled-event="storeCompResults.state.selectedEvent.compEventFiltered"
                :filter-search-term="storeCompResults.state.selectedEvent.searchTerm"
                :event-trial-map="
                  storeCompResults.state.competitionOnTheDay.trialResults[
                    storeCompResults.state.selectedEvent.compEvent.egId
                  ]
                "
                :show-heats-as-links="true"
                @searchTermChanged="storeCompResults.searchTermChanged"
                @gotoQualifyingEvent="storeCompResults.gotoQualifyingEvent"
              />
            </div>
            <!--/EVENT_DETAIL_CONTENT-->
          </div>
          <!--/EVENT_DETAIL-->
        </div>
      </div>
    </div>

    <!-- <TeamResults
      v-if="storeCompResults.state.apiServerResponse?.data"
      :competition-data="storeCompResults.state.apiServerResponse!.data"
    /> -->

    <SocketDebugger v-if="false" />
  </div>
</template>

<script setup lang="ts">
import ResultsSchedule from '@/components/results/schedule/ResultsSchedule.vue'
import ResultsAthletes from '@/components/results/athletes/ResultsAthletes.vue'

const props = defineProps({
  compId: {
    type: Number,
    required: true
  },
  env: {
    type: String,
    default: 'EA'
  },
  isEmbedded: {
    type: Boolean,
    default: false
  }
})
import { useStoreCompResults } from '@/components/results/store-comp-results'
import { onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'
import ResultsEntries from '@/components/results/ResultsEntries.vue'
import HeatResults from '@/components/results/HeatResults.vue'
import SectionLinkSimple from '@/common/ui/tabs/section-link-simple.vue'
import StartList from '@/components/results/start-list/StartList.vue'
import InputDebounce from '@/common/ui/fields/input-debounce.vue'
import LoadingSpinnerV2 from '@/common/ui/loading-spinner-v2.vue'
import ResultsTeamEntries from '@/components/results/teams/ResultsTeamEntries.vue'
import ButtonGenericV2 from '@/common/ui/buttons/button-generic-v2.vue'
import PrimaryLink from '@/common/ui/href/PrimaryLink.vue'
import FollowingWithButtons from '@/components/results/socket/following/FollowingWithButtons.vue'
import FieldSelect from '@/common/ui/fields/FieldSelect.vue'
import { formatDateWithSuffix } from '@/services/common-service-utils'
import EventTypeSelect from '@/common/ui/fields/EventTypeSelect.vue'
import CollapseActivator from '@/common/ui/collapse/CollapseActivator.vue'
import FormGenericInputTemplate from '@/common/ui/form/FormGenericInputTemplate.vue'
import LiveFeedSockets from '@/components/results/socket/live-feed/ui/LiveFeedSockets.vue'
import SubNavLink from '@/common/ui/tabs/sub-nav-link.vue'
import PulseIndicator from '@/common/ui/icons/PulseIndicator.vue'
import SocketDebugger from '@/components/results/admin/ui/SocketDebugger.vue'
import TeamResults from '@/components/results/team-results/TeamResults.vue'
import IndividualResults from '@/components/results/individual-results/IndividualResults.vue'
import EventJumpSelect from '@/components/results/EventJumpSelect.vue'

const storeCompResults = useStoreCompResults()
const route = useRoute()
storeCompResults.init(props.compId, props.env)

const tabQuery = (route.query.tab as string)?.toLowerCase()
if (tabQuery) {
  const tabMap: Record<string, typeof storeCompResults.state.ui.showSection> = {
    athletes: 'ATHLETES',
    schedule: 'SCHEDULE',
    'live-feed': 'LIVE_FEED',
    livefeed: 'LIVE_FEED',
    'team-results': 'TEAM_RESULTS',
    'series-results': 'INDIVIDUAL_RESULTS',
    individual: 'INDIVIDUAL_RESULTS'
  }
  const mapped = tabMap[tabQuery]
  if (mapped) {
    storeCompResults.state.ui.showSection = mapped
  }
}

function handleEventJump(egId: number) {
  const compEvent = storeCompResults.state.scheduledEvents.find((e) => e.egId === egId)
  if (compEvent) {
    storeCompResults.showDetails(compEvent, storeCompResults.state.ui.eventDetail.showTab)
  }
}

watch(
  () => storeCompResults.showStartListTab.value,
  (showStartListTab) => {
    if (
      !showStartListTab &&
      storeCompResults.state.ui.eventDetail.showTab === 'DETAIL_START_LIST'
    ) {
      storeCompResults.state.ui.eventDetail.showTab = 'DETAIL_ENTRIES'
    }
  }
)

// Re-initialize when compId or env changes (e.g., route param change)
watch(
  () => [props.compId, props.env],
  ([newCompId, newEnv]) => {
    console.log('ResultsLayout: compId/env changed, re-initializing', { newCompId, newEnv })
    storeCompResults.init(Number(newCompId), newEnv as string)
  }
)

onBeforeUnmount(() => {
  console.log('ResultsLayout onBeforeUnmount')
  storeCompResults.destroy()
})
</script>

<style>
.test-anime {
  height: auto;
  transition: height 5s ease-in;
}

.stretchy {
  transition: 1s linear; /* Adjust the duration as needed */
  height: 0;
  overflow: hidden;
}

.stretchy-visible {
  height: auto;
  min-height: 40px; /* Set a minimum height */
  max-height: 400px; /* Set a maximum height (larger than your content) */
}

.e4s-filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  margin-left: 4px;
  border-radius: 9px;
  background-color: var(--e4s-navigation-bar--primary__background, #0066cc);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  vertical-align: super;
}
</style>
